<template>
    <v-app class="white">
        <SnackBar/>
        <DialogNotification/>
        <Sidebar ref="drawer"/>
        <v-content>
            <v-container fluid grid-list-md>
                <TopBar @toggleNavBar="$refs.drawer.drawer = !$refs.drawer.drawer"/>
                <router-view></router-view>
                <div class="footer">
                    <span>COPYRIGHT @2019 Vitalify Asia, All rights Reserved</span>
                </div>
                <dialog-loader ref="dialogLoader"></dialog-loader>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import DialogLoader from './components/DialogLoader';
    import Sidebar from './components/common/Sidebar.vue';
    import TopBar from './components/common/Topbar.vue';
    import SnackBar from './components/core/SnackBar'
    import DialogNotification from './components/core/DialogNotification'

    export default {
        name: 'app',
        components: {
            Sidebar,
            TopBar,
            DialogLoader,
            SnackBar,
            DialogNotification
        },
        mounted() {
            this.$root.$dialogLoader = this.$refs.dialogLoader;
        }
    }
</script>

<style>
    #app {
        font-family: 'Montserrat', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    main {
        background-color: rgb(248, 248, 248);
    }

    #my-strictly-unique-vue-upload-multiple-image {
        font-family: 'Montserrat', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 20px;
        margin-bottom: 15px;
    }

    .mesh-result {
        width: 100% !important;
        max-width: 100% !important;
        max-height: 450px;
    }

    .disclaimer {
        font-size: 10px;
    }

    canvas {
        max-width: 100% !important;
        width: 100% !important;
    }

    .footer {
        text-align: left;
        margin: 1rem 0;
    }

    .v-list__tile--active .v-list__tile__title {
        color: white;
    }

    .list-category {
        font-family: 'Montserrat', Helvetica, Arial, sans-serif !important;

    }

    .v-list__tile__content .v-list__tile__title {
        font-size: 1rem !important;
    }

    .v-select__selection--comma {
        font-size: 1rem !important;
    }
</style>
